var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWithdrawalRequests(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 49,
    viewBox: "0 0 48 49",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.9997 2.61719C15.933 2.61719 9.33301 9.14844 9.33301 17.1308V37.4505H38.6663V17.1308C38.6663 9.14844 32.0663 2.61719 23.9997 2.61719Z",
    fill: "#CED2DB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M46 17.2842H2V46.6175H46V17.2842Z",
    fill: "#0052FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.33301 17.2842H38.6663V39.2842H9.33301V17.2842Z",
    fill: "#0A0B0D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9997 22.7842L30.4163 33.7842H17.583L23.9997 22.7842Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWithdrawalRequests);
export default __webpack_public_path__ + "static/media/withdrawal_requests.379e824e6bca588afef17aaf485adc1e.svg";
export { ForwardRef as ReactComponent };